export default () => ({

    /**
     * Дата события
     */
    date: null,

    /**
     * Флаг неактивности карточки
     */
    disabled: false,

    /**
     * Флаг развернутого списка состава исполнителей
     */
    expanded: false,

    /**
     * Флаг премьерного события
     */
    premiere: false,

    /**
     * Флаг режима заглушки
     */
    skeleton: false,

    /**
     * Флаг прозрачности фона карточки
     */
    transparent: false,

    /**
     * Директивы для корневого элемента карточки события
     */
    card: {

        /**
         * Динамическая установка CSS-классов
         */
        ['x-bind:class']() {
            return {
                'text-gray-300': this.disabled,
                'dark scheme-dark dark:scheme-neutral-800 sold-out:text-gray-300': this.premiere && !this.disabled,
                'scheme-white dark:scheme-dark sold-out:text-gray-300': !this.premiere && !this.disabled,
                'animate-pulse  motion-reduce:!animate-none': this.skeleton,
                '!bg-transparent': this.transparent
            }
        },
    },

    /**
     * Инициализация компонента
     */
    init() {

        this.date = this.$el.dataset.calendarDate;

        Alpine.nextTick().then(() => {
            this.disabled    = 'disabled' in this.$el.dataset;
            this.skeleton    = 'skeleton' in this.$el.dataset;
            this.premiere    = 'premiere' in this.$el.dataset;
            this.transparent = 'transparent' in this.$el.dataset;
        });
    }
});
